<div class="header">
  <div class="title">
    <h1>Follow-up of Recommendations</h1>
  </div>
  <div
    class="profile-section"
    (mouseenter)="showProfileInfo = true"
    (mouseleave)="showProfileInfo = false">
    <button mat-icon-button>
      <mat-icon>account_circle</mat-icon>
    </button>
    @if (showProfileInfo) {
    <div class="profile-info">
      <div class="profile-header">
        <mat-icon class="profile-icon">account_circle</mat-icon>
        <div class="profile-name">{{ currentUser().displayName || 'User' }}</div>
      </div>
      <div class="profile-details">
        <div class="detail-item">
          <span class="label">Email:</span>
          <span class="value">{{ currentUser().mail || 'N/A' }}</span>
        </div>
        <div class="detail-item">
          <span class="label">Roles:</span>
          <span class="value">{{ roles().appRegistrationRoles.join(', ') }}</span>
        </div>
      </div>
    </div>
    }
  </div>
  <div class="logo">
    <img
      src="../../assets/images/auto-neum-logo.png"
      alt="Logo" />
  </div>
  <br class="navigation" />

  <div class="autoneum-nav">
    <span
      class="nav-span {{ getClass('0') }}"
      (click)="goTo(0)"
      (keydown.enter)="goTo(0)"
      (keydown.space)="goTo(0)"
      tabindex="0"
      aria-label="Go to My Site">
      My Site
    </span>
    @if (isGPIA()) {
    <span
      class="nav-span {{ getClass('1') }}"
      (click)="goTo(1)"
      (keydown.enter)="goTo(1)"
      (keydown.space)="goTo(1)"
      tabindex="0"
      aria-label="Go to GPIA">
      GPIA
    </span>
    } @if (isGPRM()) {
    <span
      class="nav-span {{ getClass('2') }}"
      (click)="goTo(2)"
      (keydown.enter)="goTo(2)"
      (keydown.space)="goTo(2)"
      tabindex="0"
      aria-label="Go to GPRM">
      GPRM
    </span>
    } @if (isAdmin()) {
    <span
      class="nav-span {{ getClass('3') }}"
      (click)="goTo(3)"
      (keydown.enter)="goTo(3)"
      (keydown.space)="goTo(3)"
      tabindex="0"
      aria-label="Go to ADMIN">
      ADMIN
    </span>
    }
  </div>
</div>
